export function addMenu(meuns, data) {
  meuns.forEach((meun) => {
    if (meun.type == 'menu') {
      meun.hidden = !data.find((item) => {
        return item.menuId == meun.menuId;
      });
    } else {
      let temp = meun.menus.find((tMeun) => {
        return data.find((item) => {
          return item.menuId == tMeun.menuId;
        });
      });
      meun.hidden = !temp;
      if (temp) {
        meun.menus.forEach((item1) => {
          let temp1 = data.find((item) => {
            return item.menuId == item1.menuId;
          });
          item1.hidden = !temp1;
          if (item1.menus && temp1) {
            item1.menus.forEach((sMeun) => {
              sMeun.hidden = !temp1.childMenus.find((item) => {
                return item.menuId == sMeun.menuId;
              });
            });
          }
        });
      }
    }
  });
  //行政过滤完成
  return meuns;
}

// 前端路由根据后端返回的数据权限过滤
export function filterAsyncRoutes(routes, roleMenuIds) {
  return routes
    .filter((route) => {
      return roleMenuIds.includes(route.menuId);
    })
    .map((route) => {
      return {
        ...route,
        menus: route.menus && route.menus.length ? filterAsyncRoutes(route.menus, roleMenuIds) : [],
      };
    });
}
